import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SessionProvider } from './contexts/SessionContext';
import CodeValidationPage from './pages/CodeValidationPage';
import GeoValidationPage from './pages/GeoValidationPage';
import DoorControlPage from './pages/DoorControlPage';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <SessionProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<CodeValidationPage />} />
            <Route 
              path="/geo-validation" 
              element={
                <ProtectedRoute requireValidation={true} requireGeoValidation={false}>
                  <GeoValidationPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/door-control" 
              element={
                <ProtectedRoute requireValidation={true} requireGeoValidation={true}>
                  <DoorControlPage />
                </ProtectedRoute>
              } 
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </SessionProvider>
  );
}

export default App;
